import { JobStore } from './JobStore';
import { Batch } from './Batch';
import { BatchCoordinator } from './BatchCoordinator';
import { JobMonitor } from './JobMonitor';

export class IaJobs {
  static install (store) {
    JobMonitor.install(store);
    Batch.install(store);
    BatchCoordinator.install(store);
    JobStore.install(store);
  }
}



// WEBPACK FOOTER //
// ./src/shared/stores/image-analysis/jobs/index.js